<div fxLayout="column" fxLayoutAlign="space-between ">
  <div fxFlex>
    <h3 fxFlex fxLayoutAlign="start center">Book a demo call</h3>
    <sbnb-button fxFlex fxLayoutAlign="end center" label="Close" (clicked)="close()"></sbnb-button>
  </div>

  <div
    class="dialog-body"
    fxLayout
    fxLayoutAlign="start start"
    fxLayoutGap="12px"
    style="overflow: hidden; height: 756px">
    <div
      *ngIf="meetingUrl"
      style="width: 100%; max-height: 756px"
      class="meetings-iframe-container"
      [attr.data-src]="meetingUrl"></div>
  </div>
</div>
